// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { deactivateRetailer } from "@synd/App/Services/RetailerManagementServices";
import loadRetailerManagementUsers from "@synd/App/Handlers/RetailerManagement/LoadUsers";
import { CustomAppState } from "@synd/App/Store/Reducers";

type HandlerType = ApiHandlerDiscreteParameter<
    { id: string } & HasOnSuccess & HasOnError<string>,
    { id: string },
    ServiceResult<any>
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await deactivateRetailer(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ResetData: HandlerType = props => {
    if (props.apiResult.successful) {
        const params = (props.getState() as CustomAppState).xRetailerManagement.getRetailUsersParameter;
        if (props.apiResult.successful) {
            props.dispatch(loadRetailerManagementUsers(params));
        }
    }
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    ResetData,
];

const deactivateRetailerHandler = createHandlerChainRunner(chain, "deactivateRetailerHandler");
export default deactivateRetailerHandler;
